const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://ds2df8fwld.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://vnnm2c16ce.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://szy3b58fdk.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.us.forwood.one'
  },
  configurationService: {
    URL: 'https://config.us.forwood.one',
    WEBSOCKET: 'wss://worao5bibi.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;